import { getMyCourse } from "@/lib/api";
import { queryKeys } from "@/lib/query-keys";
import { useQuery } from "@tanstack/react-query";

const THREE_HOURS = 3 * 60 * 60 * 1000;

export function useCourseContent(courseId: string) {
	return useQuery({
		queryKey: queryKeys.courses.content(courseId),
		queryFn: () => getMyCourse(courseId),
		enabled: !!courseId,
		staleTime: THREE_HOURS,
	});
}
